import { Center, Text } from "@mantine/core";

export function InedxPage() {
    return <>
        <Center>
            <Text fw={700} style={{ fontSize: "40px" }} variant="gradient" gradient={{ from: 'blue', to: 'cyan', deg: 90 }}>
                AI ChatBot
            </Text>
        </Center>
    </>
}